import styled from 'styled-components';
import PropTypes from 'prop-types';
import Column from './Column';
import Row from './Row';

const Grid = styled.div`
  width: ${props => props.width};

  ${Column} {
    padding: 0 ${props => `${(props.gutter || props.theme.legacy.grid.gutter) / 2}px`};
  }

  ${Row} {
    margin: 0 ${props => `${((props.gutter || props.theme.legacy.grid.gutter) / 2) * -1}px`};
  }
`;

Grid.defaultProps = {
  width: '100%',
  gutter: null,
};

Grid.propTypes = {
  width: PropTypes.string,
  gutter: PropTypes.number,
};

/**
 * @deprecated Use the Grid component from OPL (/OPL/Grid/Grid.ts)
 * thanks <3
 */
export default Grid;
